<template>
  <v-card :outlined="$vuetify.theme.dark">
    <v-card-text class="pl-4 text-left overflow-hidden">
      <p class="d-flex justify-start text-h5 text--primary mb-1">
        <v-icon class="pr-2">
          mdi-account-multiple
        </v-icon>
        Tables
      </p>
      <v-card-title
        class="text-h6 text-center justify-center"
        style="font-size: 32pt !important;"
      >
        {{ tables.length }}
      </v-card-title>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CardTableCount",
  props: {
    tables: {type: Array, required: true, default: null},
  },
}
</script>

<style scoped>

</style>